import Card from './components/card'
import Logo from './components/logo'
import AppLinkLogo from './components/app-link-logo'
import HeaderFields from './components/header-fields'
import Barcode from './components/barcode'
import StripImage from './components/strip-image'
import SecondaryAndAuxillaryFields from './components/secondary-and-auxillary-fields.jsx'

const Coupon = ({ passFieldCount }) => {

  return (
    <div className="relative">
      <Card >
        <Logo />
        <HeaderFields maxFields={passFieldCount.header} />
        <StripImage maxFields={passFieldCount.primary} />
        <SecondaryAndAuxillaryFields passFieldCount={passFieldCount} />
        <AppLinkLogo />
        <Barcode />
      </Card>
      <Clipmap />
    </div>
  )
}

export default Coupon

const Clipmap = () => (
  <svg className='apple-svg-clip absolute top-0'>
    <defs>
      <clipPath id="apple_clip_path">
        <polygon id="clip" points="19.878 523 25.13 514.551 30.382 523 35.625 514.551 40.859 523 46.102 514.551 51.345 523 56.589 514.551 61.832 523 67.083 514.551 72.335 523 77.587 514.551 82.839 523 88.09 514.551 93.333 523 98.585 514.551 103.828 523 109.071 514.551 114.323 523 119.566 514.551 124.826 523 130.078 514.551 135.33 523 140.582 514.551 145.833 523 151.076 514.551 156.328 523 161.58 514.551 166.84 523 172.092 514.551 177.344 523 182.595 514.551 187.847 523 193.099 514.551 198.359 523 203.611 514.551 208.863 523 214.123 514.551 219.375 523 224.635 514.551 229.887 523 235.148 514.551 240.399 523 245.66 514.551 250.911 523 256.172 514.551 261.432 523 266.684 514.551 271.944 523 277.205 514.551 282.457 523 287.708 514.551 292.96 523 298.212 514.551 303.472 523 308.724 514.551 313.984 523 319.245 514.551 324.505 523 329.766 514.551 335.026 523 340.295 514.551 345.556 523 350.816 514.551 356.076 523 361.337 514.551 366.606 523 371.875 514.551 375 519.552 375 6.126 371.172 0 365.911 8.449 360.642 0 355.382 8.449 350.122 0 344.861 8.449 339.601 0 334.332 8.449 329.08 0 323.811 8.449 318.559 0 313.299 8.449 308.047 0 302.786 8.449 297.526 0 292.283 8.449 287.031 0 281.771 8.449 276.51 0 271.25 8.449 265.998 0 260.738 8.449 255.486 0 250.226 8.449 244.965 0 239.714 8.449 234.462 0 229.201 8.449 223.941 0 218.689 8.449 213.438 0 208.186 8.449 202.925 0 197.674 8.449 192.422 0 187.17 8.449 181.918 0 176.658 8.449 171.406 0 166.155 8.449 160.903 0 155.651 8.449 150.399 0 145.156 8.449 139.905 0 134.644 8.449 129.392 0 124.141 8.449 118.889 0 113.646 8.449 108.394 0 103.151 8.449 97.908 0 92.656 8.449 87.405 0 82.153 8.449 76.901 0 71.649 8.449 66.406 0 61.163 8.449 55.92 0 50.677 8.449 45.434 0 40.191 8.449 34.948 0 29.696 8.449 24.444 0 19.193 8.449 13.941 0 8.689 8.449 3.438 0 0 5.532 0 521.177 4.123 514.551 9.375 523 14.627 514.551 19.878 523"/>
      </clipPath>
    </defs>
    <use href="#clip" />
  </svg>
)